import { DAYS_CODE } from '../../../../utils/constant'

export const snap = (val) => Math.round(val);

export const formatTime = (time) => {
    const h = Math.floor(time);
    const m = Math.round((time - h) * 60);

    const hour12 = h % 12 === 0 ? 12 : h % 12;
    const ampm = h < 12 ? "AM" : "PM";

    return `${hour12.toString().padStart(2, "0")}:${m
        .toString()
        .padStart(2, "0")} ${ampm}`;
};

export const formatHHMM = (decimalHours) => {
    if (decimalHours == null) return '';
    const hrs = Math.floor(decimalHours);
    const mins = Math.round((decimalHours - hrs) * 60);
    const ampm = hrs < 12 || hrs === 24 ? 'am' : 'pm';
    const hour12 = hrs === 0 || hrs === 24 ? 12 : hrs > 12 ? hrs - 12 : hrs;
    const mm = String(mins).padStart(2, '0');
    return `${hour12}:${mm} ${ampm}`;
};

export const getDefaultSchedulerData = () => {
    let defaultData = {};

    for (let i = 0; i < 7; i++) {
        defaultData[i] = [
            { id: 'Home_' + Math.random(), presetId: 'Home', start: 0, end: 8, color: "#01B5DE", name: 'Home' },
            { id: 'Away_' + Math.random(), presetId: 'Away', start: 8, end: 16, color: "#DFDFDF", name: 'Away' },
            { id: 'Night_' + Math.random(), presetId: 'Night', start: 16, end: 24, color: "#99E1F2", name: "Night" }
        ]
    }
    return defaultData;
}



export const formatSchedulerTime = (timeStr, isLastIndex = false) => {

    if (!timeStr || typeof timeStr !== "string") return null;

    const trimmed = timeStr.trim().toLowerCase();
    const ampmMatch = trimmed.match(/^(\d{1,2}):(\d{2})\s*(am|pm)$/);
    let hours, minutes;
    if (ampmMatch) {
        let h = parseInt(ampmMatch[1], 10);
        minutes = parseInt(ampmMatch[2], 10);
        const period = ampmMatch[3];
        if (h === 12 && period === 'am') h = 0;
        else if (h === 12 && period === 'pm') h = 12;
        else if (period === 'pm') h += 12;
        hours = h;
    } else {
        [hours, minutes] = timeStr.split(":").map(Number);
    }

    // ❗ validate
    if (
        isNaN(hours) ||
        isNaN(minutes) ||
        hours < 0 ||
        hours > 24 ||
        minutes < 0 ||
        minutes >= 60
    ) {
        return null;
    }

    // ❗ special case: 24:00 allowed
    if (hours === 24 && minutes !== 0) return null;
    if (isLastIndex && hours === 0) {
        return 24
    }

    return hours + minutes / 60;

}

export const frameSchedulerData = (schedules,isDarkMode=false) => {
    const schedulesObj = {};

    for (let [key, val] of Object.entries(DAYS_CODE)) {

        schedulesObj[val] = schedules[key].map((v, i, a) => {
            return {
                "id":(v['preset-id'] || v.id || v.name)+'_'+Math.random(),
                "presetId": v['preset-id'] || v.id,
                "start": formatSchedulerTime(v['start-time']),
                "end": formatSchedulerTime(v['end-time'], a.length - 1 === i),
                "color": isDarkMode? v['dark-color-code']:v['light-color-code'],
                "name": v['name']
            }
        })
    }

    return schedulesObj;

}

export const formatToHHMM = (val, isLastIndex = false) => {
  
  // Extract whole hours
  const hours = Math.floor(val);
  // Convert remainder (0.5) to minutes (30)
  const minutes = (val % 1) * 60;

  if(isLastIndex && val===24){
    return '00:00'
  }

  // Format as hh:mm with leading zeros
  return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}`;
}

export const formatScenes = (scenes,isDarkMode=false) => {
    // Convert number to string and pad with leading 0 if needed
    const formattedScenes=scenes.map(m=>{
        return {
            name:m.name,
            color:isDarkMode? m['dark-color-code']:m['light-color-code'],
            presetId: m['preset-id'],
        }
    })
    return formattedScenes;
}

export const frameSchedulerDataForSaving = (schedulesData) => {

    if (!schedulesData) return
    const schedulesObj = {}

    for (let [key, val] of Object.entries(DAYS_CODE)) {

        schedulesObj[key] = schedulesData[val].map((v, i, a) => {
            return {
                "preset-id": v.presetId || v.id,
                "start-time": formatToHHMM(v.start),
                "end-time": formatToHHMM(v.end, a.length - 1 === i),
            }
        })
    }


    return { schedules: { ...schedulesObj } };

}

export const generateHourArray = () => {
    const hours = [];
    for (let i = 0; i <= 24; i += 0.5) {
        hours.push(formatHHMM(i));
    }


    return hours;
}

